import useFilePaste from '../common/useFilePaste';
import { isSupportedVideoFile } from '../../video/compress/compressVideoEngine';

/**
 * Ctrl/Cmd+V anywhere on a video tool page drops the copied clip straight in.
 *
 * Unlike a pasted screenshot there is nothing to rename: a video reaches the
 * clipboard by being copied in the file manager, so it arrives with its own
 * name — the same reason `usePdfPaste` leaves names alone. What counts as a
 * video is the engine's own test, so the picker, drag-and-drop and paste can
 * never disagree about which files a tool takes.
 *
 * @param {(files: File[]) => void} onFiles receives the pasted video files.
 * @param {{ enabled?: boolean }} [options] pass `enabled: false` to ignore
 *   pastes while a run is in flight.
 */
export default function useVideoPaste(onFiles, { enabled = true } = {}) {
    return useFilePaste(onFiles, { enabled, accept: isSupportedVideoFile });
}
